//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


import CFooter from "@/common/Footer"
export default{
  data(){
    return{
      showA: '-1',
      productList:[
        {
          title: 'BGP多线路、独立IP地址',
          subTil: ' 基于云计算的虚拟主机服务',
          content: '具备高在线率、高安全性、高稳定性等多项优势，提供独立 IP，特别适用于对网站运行质量有较高要求的用户。',
        },
        {
          title: '硬件优秀、功能强大、标配SSD硬盘',
          subTil: '极速稳定高弹性的计算服务',
          content: '系统盘、数据盘全部采用高性能SSD固态硬盘部署，吞吐量 达千兆每秒，随机读写2万IOPS，大文件高吞吐高IO并发。',
        },
        {
          title: '实时在线开通，永久免费',
          subTil: '提供五星级的域名注册服务',
          content: '免费的目的是给用户体验、练习、以及建设非商业化的个人 网站使用，可以永久免费，但不能直接升级到付费主机。',
        },
        {
          title: '送免备案系统',
          subTil: '国内免费空间第一品牌',
          content: '阿贝云推出独创的免备案服务，您的域名可以暂时不备案，直接使用，备案后速度更快更稳定。',
        },
      ]
    }
  },
  components: {
    CFooter
  },
  methods:{
    listDown(d) {
      if(this.showA == d) {
        this.showA = '-1'
      } else {
        this.showA = d
      }
    },
  }
}



// WEBPACK FOOTER //
// ./src/components/user/freeserver.vue